export const legalResources = [
  {
    label: 'selfExclusion',
    href: 'https://www.gov.br/pt-br/servicos/plataforma-centralizada-de-autoexclusao-apostas',
  },
  {
    label: 'healthSupport',
    href: 'https://www.gov.br/saude/pt-br/assuntos/saude-de-a-a-z/s/saude-mental/nao-aposte-sua-saude',
  },
  {
    label: 'authorized',
    href: 'https://www.gov.br/fazenda/pt-br/composicao/orgaos/secretaria-de-premios-e-apostas/lista-de-empresas/empresas-autorizadas',
  },
  {
    label: 'regulation',
    href: 'https://www.gov.br/fazenda/pt-br/composicao/orgaos/secretaria-de-premios-e-apostas/apostas-de-quota-fixa/legislacao/apostas',
  },
] as const;

export const brazilRiskWarning = 'Ministério da Fazenda adverte: Apostar pode causar dependência';
